export default __webpack_public_path__ + "static/Moderat-Medium-Italic-b2f646722fbe57b8ac8113cfc3c47481.woff2";